import { isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocalstorageService } from 'src/app/core/services/localstorage.service';
import { ProductsService } from 'src/app/core/services/products/products.service';
import { ShoppingCartService } from 'src/app/core/services/shopping-cart/shopping-cart.service';
import { UserService } from 'src/app/core/services/user/user.service';
import { getPricePerPound } from 'src/app/global/utils';
import { Product } from 'src/app/interfaces/products.interface';
import { User } from 'src/app/interfaces/user.interface';

@Component({
  selector: 'app-shopping-cart',
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.scss'],
})
export class ShoppingCartComponent implements OnInit, OnDestroy {
  /** Communication to close the modal */
  @Output() closeShoppingCard: EventEmitter<any> = new EventEmitter();
  /** products of the shopping cart */
  public products: Product[] = [];
  // The price the all products of the shopping cart
  public priceProducts = 0;
  // The warehouse
  public warehouse: string;
  // Subscription to the products in the shopping cart
  public products$: Observable<any>;
  // Coverage of the user location
  public coverage: string;
  // total out of stock
  public totalOutOfstock = false;
  // is variable
  public isVariableWeight = false;
  public shippingMethod
  public citySelected
  private subs = new Subscription();
  /**
   * Current user
   */
  public user
  public isPlan3000 = false
  // is distribuidor
  public isDistribuidor = false;
  /** Validates if the user is checking out. */
  public validateCheckout: boolean = false;

  constructor(
    private shoppingCartService: ShoppingCartService,
    private userService: UserService,
    private router: Router,
    private productService: ProductsService,
    private localStorage: LocalstorageService,
    @Inject(PLATFORM_ID) protected platFormId
  ) {
    this.warehouse =
      this.userService.globalShippingMethod?.address?.inventario ||
      this.userService.globalShippingMethod?.salePoint?.bodega;
    // Nos subscribimos a los productos agregados. Realizamos un async pipe para las desubscripción.
    this.products$ = this.shoppingCartService.cart$.pipe(
      map((products) => {
        this.getPriceProducts(products);
        this.stockTotal(products);
        this.products = products;
        return products.length;
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {
    // let size = this.verifSize();
    // let cart = document.getElementById('cart');
    // cart.style.height = (size[1] - 187).toString();
    if (isPlatformBrowser(this.platFormId)) {
      this.coverage = this.localStorage.getItem('cobertura');
      this.user = JSON.parse(this.localStorage.getItem('user')) as User;
      if (this.user) {
        if (this.user.idListaPrecios && this.user.idPlan3000) {
          this.isPlan3000 = true
        }
      }
    }
    this.subs.add(
      this.shoppingCartService.cart.subscribe((value) => {
        this.getPriceProducts(value);
        this.stockTotal(value);
        this.products = value;

        this.products.forEach((p) => {
          p.quantity = p.quantity ? p.quantity : p.cantidad;

          if (this.user?.idListaPrecios) {
            if (!p.listaPrecios || !Object.keys(p.listaPrecios).includes(this.user.idListaPrecios)) {
              this.deleteProduct(this.products.indexOf(p));
            }
          }
        });
      })
    );
    if (this.router.url === '/checkout') this.validateCheckout = true;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.onCloseShoppingCart();
      }
    })
    this.shippingMethod = JSON.parse(this.localStorage.getItem('shippingMethod',));
    this.citySelected = JSON.parse(this.localStorage.getItem('citySelected'));
    this.isDistribuidor = this.productService.verifyDistribuidor(this.shippingMethod, this.citySelected)
  }

  /**
   * Close the shopping cart
   */
  public onCloseShoppingCart(): void {
    this.closeShoppingCard.emit(this.priceProducts);
  }

  /**
   * It says if the products do not have stock
   * @param products;
   */
  public stockTotal(products) {
    const noStockCount = products.filter(p => this.isNoStock(p)).length;
    this.totalOutOfstock = !!products.length && noStockCount === products.length;
  }

  /**
   * less product
   *
   * @param position postion of the product in the array
   */
  public onLessProduct(position: number): void {
    const prod = this.products[position];
    if (!prod) return;

    if (prod.quantity === 1) {
      this.deleteProduct(position);
      return;
    }

    prod.quantity--;
    this.shoppingCartService.addProductsCart(prod);
  }

  /**Seasonal Holidays 2022
Camera search

   * More product
   * @param position postion of the product in the array
   */
  public onMoreProduct(position): void {
    this.products[position].quantity++;
    this.shoppingCartService.addProductsCart(this.products[position]);
  }

  /**
   * Delete producto of the shopping cart
   * @param position postion of the product in the array
   */
  public deleteProduct(position: number): void {
    const prod = this.products[position];
    if (!prod) return;

    this.isVariableWeight = false;
    this.isDistribuidor = false;

    prod.quantity = 0;
    prod.add = false;
    this.shoppingCartService.addProductsCart(prod);

    // si te quedas sin productos y estás en checkout, vuelve a home
    if (!this.products?.length && this.router.url === '/checkout') {
      this.router.navigateByUrl('/');
      this.onCloseShoppingCart();
    }
  }

  /**
   * Clean shopping cart
   */
  public onEmptyShoppingCart(): void {
    this.isVariableWeight = false;
    this.isDistribuidor = false;
    this.shoppingCartService.emptyShoppingCart();

    // Redirect to homepage if the cart is emptied
    if (this.router.url === '/checkout') {
      this.router.navigateByUrl('/');
      this.onCloseShoppingCart();
    }
  }

  /**
   * Summation of the shopping cart
   * @param Products of the shopping cart
   */
  public getPriceProducts(products: Product[]): void {
    let price = 0;

    products.forEach((p) => {
      const qty = p.quantity ? p.quantity : p.cantidad;
      const stockOk = !this.warehouse || this.user?.tipoCuenta === 'B2B' || (p.inventarioBodega?.[this.warehouse] ?? 0) >= qty;

      if (stockOk && !this.isNoStock(p)) {
        if (p.pesoVariable) {
          price += (p.precio / p.pesoGramos) * p.pesoGramosVariable * qty;
        } else {
          price += p.precio * qty;
        }
      }
    });

    this.isVariableWeight = products.some(p => !!p.pesoVariable);

    this.priceProducts = price;
  }

  /**
   * Navigate to checkout
   * @param category products category
   */
  public navigateCheckout(): void {
    this.products = JSON.parse(JSON.stringify(this.products));
    var productosFiltrados = this.products.filter(
      (p) => {
        if (this.user && this.user.tipoCuenta === 'B2B') {
          return true;
        } else {
          return p.inventarioBodega[this.warehouse] >= p.quantity;
        }
      }
    );
    if (this.isPlan3000) {
      const productosFiltradosDos = productosFiltrados.filter(
        (fp) => {
          if (fp.listaPrecios) {
            if (fp.listaPrecios['028']) return fp;
          }
        }
      );
      productosFiltrados = productosFiltradosDos;
    }
    this.shoppingCartService.cleanAndAddProducts(productosFiltrados);

    if (this.router.url !== '/checkout') {
      this.router.navigate(['/checkout']);
    } else {
      this.onCloseShoppingCart();
    }
  }

  /**
   * Function to determine if the product does not have stock by plan 3000 or in general in the store
   * @param product Product to be verified
   * @returns boolean variable that indicates whether or not it has stock
   */
  public isNoStock(product) {
    if (this.user?.tipoCuenta === 'B2B') return false;
    if (this.isPlan3000 && (!product.listaPrecios || !product.listaPrecios['028'])) {
      return true;
    }

    const stock = product.inventarioBodega?.[this.warehouse];
    if (stock === undefined) return true;

    return stock < (product.quantity ?? 0);
  }

  public isDisabled() {
    let disable = false
    if ((this.priceProducts == 0) || (this.user && this.user.estado && this.user.estado == 'Deshabilitado')) disable = true
    return disable
  }
  pricePerPound(price: number, weightGramsVariable: number, weightGrams: number) {
    return getPricePerPound(price, weightGramsVariable, weightGrams);
  }

  public hasStockForOneMore(p: Product): boolean {
    const stock = p.inventarioBodega?.[this.warehouse] ?? 0;
    return !this.isNoStock(p) && stock > (p.quantity ?? 0);
  }

  public shouldShowTrash(p: Product): boolean {
    return (p.quantity ?? 0) === 1;
  }

  public poundsApprox(p: Product): number {
    if (!p?.pesoVariable) return 0;
    const lbs = (p.pesoGramosVariable / 1000) * 2;
    return Math.round(lbs * 10) / 10; // 1 decimal
  }
}
